import { buildCartLineId, getProductImage } from "./productUtils";

function toOptionValues(selectedOptions) {
  if (!Array.isArray(selectedOptions) || !selectedOptions.length) return {};
  return selectedOptions.reduce((acc, option) => {
    const label = String(option?.label || "").trim();
    if (!label) return acc;
    acc[label] = option?.value || "";
    return acc;
  }, {});
}

export function buildCartLinesFromOrder(order) {
  const items = Array.isArray(order?.items) ? order.items : [];

  return items
    .map((item, index) => {
      const productId = String(item?.productId || "").trim();
      if (!productId) return null;

      const variantId = String(item?.variantId || "").trim();
      const optionValues = toOptionValues(item?.selectedOptions);
      const variableSelection = item?.variableSelection && Number(item.variableSelection.value) > 0
        ? {
            value: Number(item.variableSelection.value),
            unit: String(item.variableSelection.unit || "").trim(),
          }
        : null;

      const lineId = buildCartLineId(productId, variantId, optionValues, variableSelection);
      const lineSuffix = index > 0 ? `-${index}` : "";

      const snapshot = {
        _id: productId,
        name: item?.productSnapshot?.name || "Prodotto",
        images: item?.productSnapshot?.image ? [{ url: item.productSnapshot.image }] : [],
        price: {
          vat: Number(item?.productSnapshot?.price?.vat) || 0,
        },
      };

      return {
        id: `${lineId}${lineSuffix}`,
        productId,
        productName: item?.productSnapshot?.name || "Prodotto",
        imageUrl: getProductImage(snapshot),
        quantity: Math.max(1, Number(item?.quantity) || 1),
        unitPrice: Number(item?.unitPrice) || 0,
        variantId,
        variantLabel: item?.variantName || "",
        optionValues,
        optionSignature: "",
        optionSummaries: Array.isArray(item?.selectedOptions)
          ? item.selectedOptions.map((option) => ({
              label: option?.label || "",
              value: option?.value || "",
              priceAddon: Number(option?.priceAddon) || 0,
            }))
          : [],
        variableSelection,
        notes: item?.notes || "",
        isConfigurable: Boolean(variantId) || Boolean(variableSelection) || (Array.isArray(item?.selectedOptions) && item.selectedOptions.length > 0),
        productSnapshot: snapshot,
      };
    })
    .filter(Boolean);
}
